export default function ShowcaseHeader({ title, subtitle }) {
  return (
    <div className="text-center mb-10 reveal">
      <span className="label-eyebrow inline-flex items-center gap-2">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[var(--accent)] opacity-75" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-[var(--accent)]" />
        </span>
        Work in progress
      </span>
      <h2 className="font-heading text-4xl sm:text-5xl mt-3 mb-3">{title}</h2>
      <p className="text-[var(--body)] text-lg max-w-xl mx-auto">{subtitle}</p>
    </div>
  );
}
